import { render, staticRenderFns } from "./UsuarioForm.vue?vue&type=template&id=3c899283&"
import script from "./UsuarioForm.vue?vue&type=script&lang=js&"
export * from "./UsuarioForm.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports